// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","divider":"Card_divider__3g_g5","text":"Card_text__nO5sW","button":"Card_button__19Of0"};